import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { useTooltipClassNames } from './hooks/useTooltipClassNames';
import { TooltipRoot, TooltipArrow } from './style';
import { tooltipDefaultTheme } from './theme';
import { TOOLTIP_CLASS_PREFIX } from './constants';
import { useTooltip } from './hooks/useTooltip';
import { PortalToBody } from '../../system/util/PortalToBody';
export var Tooltip = forwardRef(function Tooltip(_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(TOOLTIP_CLASS_PREFIX, tooltipDefaultTheme);

  var _useTooltip = useTooltip(props, ref),
      align = _useTooltip.align,
      open = _useTooltip.open,
      trigger = _useTooltip.trigger,
      validTrigger = _useTooltip.validTrigger,
      content = _useTooltip.content,
      portalProps = _useTooltip.portalProps,
      rootProps = _useTooltip.rootProps,
      arrowProps = _useTooltip.arrowProps;

  var classNameComponents = useTooltipClassNames(TOOLTIP_CLASS_PREFIX, className, align);

  if (!validTrigger) {
    return trigger || null;
  }

  return React.createElement(React.Fragment, null, trigger, open && !!content && React.createElement(PortalToBody, Object.assign({}, portalProps), React.createElement(TooltipRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNameComponents.Root
  }), content, React.createElement(TooltipArrow, Object.assign({}, arrowProps, {
    theme: theme,
    className: classNameComponents.Arrow
  })))));
});
Tooltip.defaultProps = {
  align: 'top',
  error: false,
  small: false
};